import { render, staticRenderFns } from "./VehicleDictionarySelect.vue?vue&type=template&id=16d27f38&scoped=true"
import script from "./VehicleDictionarySelect.ts?vue&type=script&lang=ts&external"
export * from "./VehicleDictionarySelect.ts?vue&type=script&lang=ts&external"
import style0 from "./VehicleDictionarySelect.scss?vue&type=style&index=0&id=16d27f38&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d27f38",
  null
  
)

export default component.exports